import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * ScrollToTop — every route change lands the visitor at top of page.
 * React Router remembers the previous scroll position by default;
 * the family wants every page to open at its front door, not the middle.
 * Uses instant scroll on route change (no jarring animation between screens).
 */
export default function ScrollToTop() {
  const { pathname, search } = useLocation();
  useEffect(() => {
    // Instant scroll to (0,0). Any nested scroll containers on the page
    // stay where they are — this only resets the window itself.
    window.scrollTo({ top: 0, left: 0, behavior: "instant" });
  }, [pathname, search]);
  return null;
}
